import React, { FunctionComponent, PropsWithChildren } from 'react';

import {
  default as MuiTextField,
  TextFieldProps,
} from '@mui/material/TextField';

const Input: FunctionComponent<TextFieldProps> = (
  props: PropsWithChildren<TextFieldProps>
) => {
  return <MuiTextField {...props}>{props.children}</MuiTextField>;
};

export default Input;
